/**
 * Curated examples that teach shoppers to describe a car in a sentence, shown in the inline
 * PLP search dropdown while the input is empty.
 *
 * Selecting one opens natural-language search rather than the lexical keyword slug — see
 * `KeywordSearchResultsSection`.
 */
export const KEYWORD_SEARCH_PROMPTS = [
  'Reliable family SUV under $30k',
  'First car for a new driver',
  'Ute for work and weekends',
  'Electric car for city driving',
  'Low kms automatic under $20k',
  '7 seater for road trips',
] as const;

export const KEYWORD_SEARCH_PROMPTS_TITLE = 'Try describing what you need';
